import React from "react";

export default function OrLine() {
    return (
        <div className='text-navLink text-sm font-normal text-center relative after:w-full after:h-px after:bg-navLink after:content-[""] w-full after:absolute after:-translate-y-1/2 after:top-1/2 after:left-2'>
        <span className="px-4 bg-white relative z-[3] ">or</span>
      </div>

    )
}